// OWNER: platform module (offline area). Route-safe target for notification clicks (FR-11.3).
// public/sw.js has the same logic in plain JS (safeTargetPath); both are unit-tested against the same cases.

const isApiPath = (pathname: string) => pathname === '/api' || pathname.startsWith('/api/');

/**
 * Returns a same-origin, non-API path (`/w/<id>/this-week?x#y`) for a URL received in a push payload or a
 * service-worker message. Anything else (other origins, `//evil.example`, `javascript:` URLs, backslashes,
 * control characters, junk) returns `/`.
 */
export function safeNotificationPath(raw: unknown, origin: string): string {
  const fallback = '/';
  if (typeof raw !== 'string') return fallback;
  const value = raw.trim();
  if (!value || value.length > 2048) return fallback;
  // eslint-disable-next-line no-control-regex
  if (/[\u0000-\u001f\u007f\\]/.test(value)) return fallback;
  let url: URL;
  try {
    url = new URL(value, origin);
  } catch {
    return fallback;
  }
  if (url.origin !== origin) return fallback;
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return fallback;
  if (isApiPath(url.pathname)) return fallback;
  return `${url.pathname}${url.search}${url.hash}`;
}
